import getCookie from './getCookie.js';

export default function getAuthTokenExpirationCookie() {
  return getCookie('auth-token-expiration');
}
